import React, { createContext, useState, useContext, useEffect } from 'react';

const LangContext = createContext();

export const LangProvider = ({ children }) => {
    // LocalStorage se language uthao, default 'en' (English)
    const [lang, setLang] = useState(localStorage.getItem('appLang') || 'en');

    useEffect(() => {
        localStorage.setItem('appLang', lang);
    }, [lang]);

    // Hindi Dictionary
    const dictionary = {
        en: {
            home: "Home",
            items: "Items",
            cart: "Cart",
            orders: "Orders",
            profile: "Profile",
            search: "Search items...",
            add_to_order: "ADD TO ORDER",
            added: "ADDED",
            out_of_stock: "OUT OF STOCK",
            inquiry: "Inquiry",
            ask_availability: "Ask Availability",
            welcome: "Welcome",
            place_order: "Place Order",
            total: "Total",
            delivery_address: "Delivery Address",
            my_profile: "My Profile",
            edit_profile: "Edit Profile",
            save_changes: "Save Changes",
            logout: "Logout",
            dark_mode: "Dark Mode",
            light_mode: "Light Mode",
            language: "Change Language",
            qty: "Qty",
            item_code: "Code"
        },
        hi: {
            home: "होम",
            items: "सामान",
            cart: "झोला",
            orders: "ऑर्डर",
            profile: "प्रोफाइल",
            search: "सामान खोजें...",
            add_to_order: "ऑर्डर करें",
            added: "जुड़ गया ✔",
            out_of_stock: "खत्म है",
            inquiry: "पूछताछ करें",
            ask_availability: "कब मिलेगा?",
            welcome: "स्वागत है",
            place_order: "ऑर्डर भेजें",
            total: "कुल",
            delivery_address: "डिलीवरी का पता",
            my_profile: "मेरी प्रोफाइल",
            edit_profile: "बदलाव करें",
            save_changes: "सेव करें",
            logout: "लॉग आउट",
            dark_mode: "डार्क मोड",
            light_mode: "लाइट मोड",
            language: "भाषा बदलें",
            qty: "मात्रा",
            item_code: "कोड"
        }
    };

    // Helper function to get text
    const t = (key) => dictionary[lang][key] || key;

    return (
        <LangContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LangContext.Provider>
    );
};

export const useLang = () => useContext(LangContext);